const blogFilters = () => {
  const filterButtons = document.querySelectorAll('.filter-button');
  const blogThumbnails = document.querySelectorAll('.thumbnail-wrapper');
  const blogs23Wrapper = document.querySelector('.blogs-2-and-3');
  const featuredArticle1 = document.querySelector('.featured-blog');
  const blogListWrapper = document.querySelector('.blog-list-wrapper');
  const filterHeading = document.getElementById('filterHeading');

  if (filterHeading) {
    // Store the initial heading value in a data attribute
    filterHeading.dataset.initialHeading = filterHeading.textContent;
  }

  if (filterButtons) {
    // Attach click event listeners to filter buttons
    filterButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const selectedTag = this.dataset.tag;

        // If the clicked filter button is already active, remove the filter
        if (this.classList.contains('active')) {
        // Show all blog thumbnails
          blogThumbnails.forEach(function(thumbnail) {
            thumbnail.style.display = 'grid';
          });

          blogs23Wrapper.style.display = 'block';
          featuredArticle1.style.display = 'block';

          // Remove active class from the clicked filter button
          this.classList.remove('active');

          // Remove active class from blog-list-wrapper if no other filters are active
          const activeFilters = document.querySelectorAll('.filter-button.active');
          if (activeFilters.length === 0) {
            blogListWrapper.classList.remove('blog-list-wrapper--active');
            filterHeading.textContent = filterHeading.dataset.initialHeading; // Restore the initial value of filterHeading
          }
        } else {
        // Hide all blog thumbnails initially
          blogThumbnails.forEach(function(thumbnail) {
            thumbnail.style.display = 'none';
          });

          // Show blog thumbnails with the selected tag
          const filteredThumbnails = document.querySelectorAll('.thumbnail-wrapper.' + selectedTag);
          filteredThumbnails.forEach(function(thumbnail) {
            thumbnail.style.display = 'grid';
          });

          blogs23Wrapper.style.display = 'none';
          featuredArticle1.style.display = 'none';

          // Remove active class from all filter buttons
          filterButtons.forEach(function(button) {
            button.classList.remove('active');
          });

          // Add active class to the clicked filter button
          this.classList.add('active');

          // Add active class to blog-list-wrapper
          blogListWrapper.classList.add('blog-list-wrapper--active');

          filterHeading.textContent = this.textContent; // Update the heading with the selected filter button text
        }
      });
    });
  }

  // Attach click event listener to a "Clear Filter" button
  const clearFilterButton = document.getElementById('clearFilterButton');
  if (clearFilterButton) {
    clearFilterButton.addEventListener('click', function() {
    // Show all blog thumbnails
      blogThumbnails.forEach(function(thumbnail) {
        thumbnail.style.display = 'grid';
      });

      blogs23Wrapper.style.display = 'grid';
      featuredArticle1.style.display = 'grid';

      // Remove active class from all filter buttons
      filterButtons.forEach(function(button) {
        button.classList.remove('active');
      });

      // Remove active class from blog-list-wrapper
      blogListWrapper.classList.remove('blog-list-wrapper--active');

      filterHeading.textContent = filterHeading.dataset.initialHeading; // Restore the initial value of filterHeading
    });
  }
}
  
export default blogFilters;
  